import styled from 'styled-components';

export const Page = styled.div.withConfig({ displayName: '-Page' })`
	width: calc(100% / 5);
	height: 100%;
`;
